type ListEditionError = {
  emptyName: boolean;
  duplicateName: boolean;
  invalidDateRange: boolean;
  startDateOutOfBound: boolean;
  notFound: boolean;
  listNotFound: boolean;
};

const listEditionError: ListEditionError = {
  emptyName: false,
  duplicateName: false,
  invalidDateRange: false,
  startDateOutOfBound: false,
  notFound: false,
  listNotFound: false,
};

export type { ListEditionError };

export { listEditionError };
